import classNames from 'classnames';
import { Tag } from 'sonata-react-components';

import type { CSSProperties, ReactNode } from 'react';

import './kpiCard.scss';

export type KpiCardProps = {
  iconClass: string;
  iconColor: string;
  iconContainerStyle: CSSProperties;
  value: string;
  label: string;
  labelPrimary?: boolean;
  labelTooltip?: ReactNode;
  children?: ReactNode;
  tagConfig?: Record<string, any>;
  iconTooltip?: ReactNode;
};

/**
 * Metric card shared by the driveToStore and DOOH reports.
 *
 * Extracted from `driveToStore/common/KpiOverview/PrimaryKpiCard`, which now
 * re-exports it under its former name. The `kpiOverview__*` class names are kept
 * verbatim so the driveToStore report renders byte-identically after the move.
 */
export function KpiCard({
  iconClass,
  iconColor,
  iconContainerStyle,
  value,
  label,
  labelPrimary,
  labelTooltip,
  children,
  tagConfig,
  iconTooltip
}: KpiCardProps) {
  return (
    <div className="kpiOverview__primaryCard">
      {tagConfig && (
        <div className="kpiOverview__tagRow">
          <Tag
            icon={{
              position: 'left',
              webFont: tagConfig.icon
            }}
            id={`${label}-tag`}
            status="ok"
          >
            {tagConfig.text}
          </Tag>
        </div>
      )}
      <div className="kpiOverview__primaryTop">
        <div className="kpiOverview__iconContainer" style={iconContainerStyle}>
          <i className={classNames(iconClass, 'kpiOverview__primaryIcon')} style={{ color: iconColor }} />
        </div>
        <div className="kpiOverview__primaryValueGroup">
          {iconTooltip}
          <span className="kpiOverview__primaryValue">{value}</span>
        </div>
      </div>
      <div className="kpiOverview__labelRow">
        <span className={classNames('kpiOverview__label', { 'kpiOverview__label--primary': labelPrimary })}>
          {label}
        </span>
        {labelTooltip}
      </div>
      {children}
    </div>
  );
}
